export default __webpack_public_path__ + "static/media/Fredoka-Light.882f556f.ttf";